import { inspect } from 'util';

export const isNotEmpty = (array?: string): boolean => (array?.length ?? 0) > 0;

export const stringOrUndefined = (value: unknown): string | undefined =>
  typeof value === 'string' ? value : undefined;

export const stringOrInspect = (value: string | Record<string, unknown>): string =>
  typeof value === 'string' ? value : inspect(value);
